import React from 'react';
import Button from 'components/common/Button';
import userDataDownloadQuery from 'ApolloClient/Queries/userDataDownload';
import ApolloClient from 'ApolloClient/index.js';
import Papa from 'papaparse';
import moment from 'moment';
// APOLLO

const downloadFile = (data, exportFilename) => {
  let csvData = new Blob([data], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(csvData, exportFilename);
  } else {
    // In FF link must be added to DOM to be clicked
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(csvData);
    link.setAttribute('download', exportFilename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

class DownloadClientsButton extends React.PureComponent {
  state = {
    loading: false,
  };

  shapeData = data => data.map(client => ({
    email: client.email,
    last: client.lastName,
    first: client.firstName,
    phone: client.phone,
    status: client.status,
    image: client.image,
    description: client.description,
    website: client.website,
    country: client.country,
    zip: client.zip,
    city: client.city,
    street1: client.street1,
    street2: client.street2,
    createdAt: client.createdAt && moment(client.createdAt).format('M/D/YYYY hh:mm a'),
    whereDidYouHearAboutUs: client.whereDidYouHearAboutUs,
  }));

  generateCSV = data => {
    let cleanData = this.shapeData(data);
    let dataSource = Papa.unparse(cleanData, { header: true });
    downloadFile(dataSource, 'client-data.csv');
    this.setState({ loading: false });
  };

  onClick = () => {
    this.generateCSV(this.props.dataSource);
  };

  render() {
    return (
      <div>
        <Button icon="cloud-download" type="dashed" onClick={this.onClick}>
          Download Client Data
        </Button>
      </div>
    );
  }
}

export default DownloadClientsButton;



// WEBPACK FOOTER //
// ./src/routes/app-clients/ClientsTable/DownloadClientsButton/index.js